import React from 'react';

import Validation, { Form } from 'modules/react-validation';

import ParameterSet from 'sharedreact/components/ParameterSet';
import TextField from 'sharedreact/components/TextField';
import hideable from 'sharedreact/components/hideable';
import { translate } from 'sharedreact/utils/LanguageSupport';

import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

const SECRET_PLACEHOLDER: string = '12d456U8901m3456m8Y012s4567eCR123e456t90';

type Props = {
  openIDConfig: OpenIDConfig,
  className?: string,

  onChangeValue: (name: string, value: any) => void,
  onValidate: () => void,
  setForm: (form: Form | null) => void
};

class OpenIDOktaConfigPanel extends React.Component<Props> {
  private form: Form | null;

  constructor (props: Props) {
    super(props);

    this.form = null;

    this.handleValidate = this.handleValidate.bind(this);
  }

  handleValidate (name: string): void {
    if (this.form != null) {
      this.form.validate(name);
      this.props.onValidate();
    }
  }

  override render (): React.ReactNode {
    const { openIDConfig, className,
      onChangeValue, setForm } = this.props;

    return (
      <Validation.components.Form
        className={className}
        ref={(e) => {this.form = e; setForm(e);}}
      >
        <ParameterSet useProvider={false}>
          <TextField id='ae_text_authentication_oidc_okahost'
            name='oktahost'
            value={openIDConfig.oktahost}
            label={translate('launcher.identityproviders.oidc.oktahost')}
            onChangeValue={onChangeValue}
            validations={['required']}
            validate={this.handleValidate}
          />
          <TextField id='ae_text_authentication_oidc_clientid'
            name='clientId'
            value={openIDConfig.clientId}
            label={translate('launcher.identityproviders.oidc.clientid')}
            onChangeValue={onChangeValue}
            validations={['required']}
            validate={this.handleValidate}
          />
          <TextField id='ae_text_authentication_oidc_clientsecret'
            name='clientSecret'
            value={openIDConfig.isClientSecretEdited || openIDConfig.isNew() ? openIDConfig.clientSecret : SECRET_PLACEHOLDER}
            label={translate('launcher.identityproviders.oidc.clientsecret')}
            type='password'
            onChangeValue={onChangeValue}
            validations={['required']}
            validate={this.handleValidate}
            autoComplete='off'
          />
          <TextField id='ae_text_authentication_oidc_groupmembership'
            name='groupMembership'
            label={translate('launcher.identityproviders.oidc.groupmembership')}
            value={openIDConfig.groupMembership}
            placeholder={translate('launcher.identityproviders.oidc.groupmembership.placeholder')}
            onChangeValue={onChangeValue}
          />
        </ParameterSet>
      </Validation.components.Form>
    );
  }
}

export default hideable(OpenIDOktaConfigPanel);
